<p-card>
  <div class="p-6">
    <h2 class="text-2xl font-semibold mb-6">
      {{ 'project.steps.rfi.providerResult.title' | transloco }}
    </h2>

    <app-provider-results-table
      [projectId]="projectId"
      [phase]="TenderPhaseType.RFI"
      [scoreBars]="true"
      [allowIndividualResultsModal]="true"
    />
  </div>
</p-card>
